// src/components/UserMenu.js
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './Auth/LoginForm';

const UserMenu = () => {
  const { user, signOut, loading, authenticated, tier } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [loginMode, setLoginMode] = useState('signin');
  const [showDropdown, setShowDropdown] = useState(false);

  if (loading) {
    return (
      <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
    );
  }

  if (!authenticated) {
    return (
      <>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => { setLoginMode('signup'); setShowLogin(true); }}
            className="text-gray-700 hover:text-gray-900 px-4 py-2 rounded-lg font-medium border border-gray-200 hover:border-gray-300 transition-all duration-200"
          >
            Sign Up
          </button>
          <button
            onClick={() => { setLoginMode('signin'); setShowLogin(true); }}
            className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 font-medium"
          >
            Sign In
          </button>
        </div>

        {showLogin && (
          <LoginForm initialMode={loginMode} onClose={() => setShowLogin(false)} />
        )}
      </>
    );
  }

  const getTierColor = (tier) => {
    switch(tier) {
      case 'pro': return 'text-blue-600 bg-blue-100';
      case 'enterprise': return 'text-purple-600 bg-purple-100';
      default: return 'text-green-600 bg-green-100';
    }
  };

  return (
    <div className="relative">
      <button 
        onClick={() => setShowDropdown(!showDropdown)}
        className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
      >
        <div className="w-8 h-8 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-semibold">
          {user?.email?.[0]?.toUpperCase() || 'U'}
        </div>
        <span className="hidden md:block font-medium">
          {user?.email || 'User'}
        </span>
      </button>

      {showDropdown && (
        <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-4 border-b border-gray-100">
            <div className="font-medium text-gray-900">{user?.email || 'User'}</div>
            <div className="flex items-center mt-1">
              <span className={`px-2 py-1 rounded text-xs font-medium ${getTierColor(tier)}`}>
                {tier.toUpperCase()}
              </span>
              {user?.company_name && (
                <span className="ml-2 text-xs text-gray-500">
                  • {user.company_name}
                </span>
              )}
            </div>
          </div>
          
          <div className="py-2">
            <a 
              href="/dashboard" 
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Dashboard
            </a>
            <a 
              href="/models" 
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              My Models
            </a>
          </div>
          
          <div className="border-t border-gray-100 py-2">
            <button
              onClick={() => {
                signOut();
                setShowDropdown(false);
              }}
              className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
            >
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;